export const DEFAULT_ROW_HEIGHT = 80;
export const NEAR_BOTTOM_THRESHOLD = 100;
export const LOAD_MORE_THRESHOLD = 200;
export const OVERSCAN_COUNT = 10;
export const SCROLL_CONTAINER_TIMEOUT = 100;
export const SCROLL_CONTAINER_DATA_ATTR = 'data-virtualized-scroll-container';
